import { h } from 'preact'
import { isMobile } from '../../js/modules/utilities'

export const JeuxVideo = ({ title, URL, images, alt, analytics, cacheKey }) => {
   let adviseTags = {}
   if (analytics.pdbSc === 'adv') {
      adviseTags = {
         'data-pdb-ta': analytics.pdbTa,
         'data-adv-canal': analytics.advCanal,
         'data-adv-cappingdata': analytics.advCappingdata,
      }
   }

   return (
      <div data-testid="bande-jeux-video" data-cache-key={cacheKey}>
         <div class="container-fluid pt-2">
            <div class="row">
               <div class="col-12">
                  <h2>{title}</h2>
               </div>
            </div>
         </div>
         <div class="row no-gutters">
            <div class="col-12">
               <a
                  href={URL}
                  class="d-block overflow-hidden"
                  data-pdb-zid={analytics.pdbZid}
                  data-pdb-sc={analytics.pdbSc}
                  data-pdb-idc={analytics.pdbIdc}
                  data-pdb-vi={analytics.pdbVi}
                  {...adviseTags}
                  data-oevent-category={analytics.oeventCategory}
                  data-oevent-action={analytics.oeventAction}
                  data-oevent-label={analytics.oeventLabel}
                  data-oevent-other={analytics.oeventOther}
               >
                  {isMobile() ? (
                     <picture>
                        <source srcset={images.img1} media="(max-width: 479px)" />
                        <img src={images.img2} alt={alt} loading="lazy" class="h-100 mw-100 img" />
                     </picture>
                  ) : (
                     <picture>
                        <img src={`${images.img1}?saveas=webp`} alt={alt} loading="lazy" />
                     </picture>
                  )}
               </a>
            </div>
         </div>
      </div>
   )
}
